var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-buttons---konfigurator",
    transform: "translate(-172.000000, -330.000000)",
    stroke: "#DF3427",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "knapp",
    transform: "translate(149.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8702426,33.8702426 L44,40 L37.8702426,33.8702426 C36.3999068,35.3405784 34.3686568,36.25 32.125,36.25 C27.6376864,36.25 24,32.6123136 24,28.125 C24,23.6376864 27.6376864,20 32.125,20 C36.6123136,20 40.25,23.6376864 40.25,28.125 C40.25,30.3686568 39.3405784,32.3999068 37.8702426,33.8702426 Z",
    id: "icon_search"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoom);
export default __webpack_public_path__ + "static/media/icon-zoom.5d20fb328b3f9a3c7cc9740cae2967ac.svg";
export { ForwardRef as ReactComponent };